import React, { useEffect, useState} from 'react';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../context/AuthContext';
import StandardNavbar from '../components/StandardNavbar';
import SearchableSelect from '../components/SearchableSelect';
import Footer from '../components/Footer';
import SyncButton from '../components/SyncButton';
import GestionSeccionesHome from '../components/GestionSeccionesHome';
import GestionDestaques from '../components/GestionDestaques';
import CollapsibleSection from '../components/CollapsibleSection';
import AdminPopupPromo from '../components/AdminPopupPromo';
import GestionPromociones from '../components/GestionPromociones';
import ImageManager from '../components/ImageManager';
import { Plus, Edit2, Trash2, Save, X, Upload, Eye, Search } from 'lucide-react';

function Admin() {
  const { user } = useAuth();
  const [paquetes, setPaquetes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingPaquete, setEditingPaquete] = useState(null);
  
  // FormData con campos de PostgreSQL
  const [formData, setFormData] = useState({
  titulo: '',
  descripcion: '',
  tarifa: '',
  descuento_principal_monto: '',
  categoria: 'nacional',
  destino: '', // ← Mantener por compatibilidad
  destino_id: null, // ← NUEVO
  destino_nombre: '', // ← NUEVO
  duracion: '',
  incluye: '',
  noIncluye: '',
  fecha_salida: '',
  fecha_regreso: '',
  disponibilidad: '',
  estado: 'activo',
  imagen: '',
  destacado: false,
  home_section: '',
  fecha_publicacion: '',
  hora_publicacion: '',
  hotel: '',
  moneda: '$',
  incluye_transfer: false,
  incluye_coordinador: false
});

const [errors, setErrors] = useState({});
const [secciones, setSecciones] = useState([]);
const [paquetesExternos, setPaquetesExternos] = useState([]);
const [submitLoading, setSubmitLoading] = useState(false);

const [paginaActual, setPaginaActual] = useState(1);


const [filtrosActivos, setFiltrosActivos] = useState({
  transporte: [],
  duracion: [],
  precioMin: null,
  precioMax: null,
  fechaMin: null,
  fechaMax: null,
  disponibilidadMin: null,
  disponibilidadMax: null,
  estado: ['activo'] // ← Por defecto solo activos
});


const [destaques, setDestaques] = useState([]);
const [showDestaquesModal, setShowDestaquesModal] = useState(false);
const [showAsignarDestaquesModal, setShowAsignarDestaquesModal] = useState(false);
const [destaqueForm, setDestaqueForm] = useState({
  nombre: '',
  descripcion: '',
  color: '#FF6B6B',
  icono: '🎉'
});
const [editingDestaque, setEditingDestaque] = useState(null);
const [destaquesSeleccionados, setDestaquesSeleccionados] = useState([]);


const [opcionesTransporte, setOpcionesTransporte] = useState([]);
const [opcionesDuracion, setOpcionesDuracion] = useState([]);


const [busquedaPaquete, setBusquedaPaquete] = useState('');
const PAQUETES_POR_PAGINA = 10;

const [paginasCMS, setPaginasCMS] = useState([]);

const [estadoSincronizacion, setEstadoSincronizacion] = useState(null);
const [sincronizando, setSincronizando] = useState(false);
const [verificandoReactivaciones, setVerificandoReactivaciones] = useState(false);
const [mostrarPanelSync, setMostrarPanelSync] = useState(false);

const [editingCMS, setEditingCMS] = useState(null);
const [showCMSForm, setShowCMSForm] = useState(false);
const [cmsFormData, setCmsFormData] = useState({
  titulo: '',
  descripcion: '',
  slug: '',
  activo: true,
  secciones: []
});


const [paquetesSeleccionados, setPaquetesSeleccionados] = useState([]);
const [showEdicionMasiva, setShowEdicionMasiva] = useState(false);
const [edicionMasivaData, setEdicionMasivaData] = useState({
  campo: '',
  valor: '' // Puede ser string o boolean según el campo
});


const toggleSeleccionPaquete = (paqueteId) => {
  setPaquetesSeleccionados(prev => {
    if (prev.includes(paqueteId)) {
      return prev.filter(id => id !== paqueteId);
    } else {
      return [...prev, paqueteId];
    }
  });
};

const seleccionarTodos = () => {
  if (paquetesSeleccionados.length === paquetesFiltradosConColumnas.length) {
    // Deseleccionar todos
    setPaquetesSeleccionados([]);
  } else {
    // Seleccionar TODOS los filtrados (no solo los de la página actual)
    setPaquetesSeleccionados(paquetesFiltradosConColumnas.map(p => p.id));
  }
};

const handleEdicionMasiva = async () => {
  if (paquetesSeleccionados.length === 0) {
    alert('Selecciona al menos un paquete');
    return;
  }
  
    if (!edicionMasivaData.campo) {
    alert('Debes seleccionar un campo');
    return;
  }


  // Validar valor según el tipo de campo
  if (edicionMasivaData.campo === 'destacado' || edicionMasivaData.campo === 'incluye_coordinador') {
    // Para booleanos, false es válido
    if (edicionMasivaData.valor !== true && edicionMasivaData.valor !== false) {
      alert('Debes seleccionar un valor');
      return;
    }
  } else {
    // Para otros campos, validar que no esté vacío
    if (!edicionMasivaData.valor) {
      alert('Debes seleccionar un valor');
      return;
    }
  }

  const confirmar = window.confirm(
    `¿Estás seguro de actualizar el campo "${edicionMasivaData.campo}" en ${paquetesSeleccionados.length} paquetes?`
  );
  
  if (!confirmar) return;

  try {
    const token = localStorage.getItem('token');
    
    // Buscar los paquetes completos desde el array principal
    const promises = paquetesSeleccionados.map(paqueteId => {
      const paquete = paquetes.find(p => p.id === paqueteId); // Usar 'paquetes', no 'paquetesPaginados'
      
      if (!paquete) {
        console.error(`Paquete ${paqueteId} no encontrado`);
        return Promise.resolve();
      }
      
      const bodyData = {
        titulo: paquete.titulo,
        descripcion: paquete.descripcion || '',
        //descripcion_viaje: paquete.descripcion_viaje || '',
        tarifa: parseFloat(paquete.tarifa),
        moneda: paquete.moneda || '$',
        descuento_principal_monto: parseFloat(paquete.descuento_principal_monto) || 0,
        categoria: paquete.categoria,
        duracion: paquete.duracion,
        fecha_salida: paquete.fecha_salida,
        disponibilidad: paquete.disponibilidad || 0,
        estado: paquete.estado,
        destacado: paquete.destacado || false,
        home_section: paquete.home_section || null,
        fecha_publicacion: paquete.fecha_publicacion || null,
        hora_publicacion: paquete.hora_publicacion || null,
        hotel: paquete.hotel || '',
        transporte: paquete.transporte || '',
        regimen: paquete.regimen || '',
        singles: paquete.singles || '',
        incluye_transfer: formData.incluye_transfer || false,
        // Sobrescribir el campo seleccionado
        [edicionMasivaData.campo]: 
          (edicionMasivaData.campo === 'destacado' || edicionMasivaData.campo === 'incluye_coordinador')
            ? (edicionMasivaData.valor === true || edicionMasivaData.valor === 'true')
            : edicionMasivaData.valor
      };
      
      return fetch(`${process.env.REACT_APP_API_URL}/paquetes/${paqueteId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(bodyData)
      });
    });

    const results = await Promise.all(promises);
    
    // Verificar si hubo errores
    const errores = results.filter(r => r && !r.ok);
    
    if (errores.length > 0) {
      alert(`${paquetesSeleccionados.length - errores.length} paquetes actualizados. ${errores.length} fallaron.`);
    } else {
      alert(`${paquetesSeleccionados.length} paquetes actualizados exitosamente`);
    }
    
    setPaquetesSeleccionados([]);
    setShowEdicionMasiva(false);
    setEdicionMasivaData({ campo: '', valor: '' });
    await fetchPaquetes();
  } catch (error) {
    console.error('Error en edición masiva:', error);
    alert('Error al actualizar paquetes');
  }
};


// ✅ NUEVO: Estados para FAQ de paquetes
const [faqPaquetes, setFaqPaquetes] = useState([]);
const [showFAQModal, setShowFAQModal] = useState(false);
const [faqForm, setFaqForm] = useState({
  pregunta: '',
  respuesta: '',
  orden: 0
});
const [editingFAQ, setEditingFAQ] = useState(null);

// ✅ Cargar FAQ de paquetes
const fetchFAQPaquetes = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/faq-paquetes/admin`);
    if (response.ok) {
      const data = await response.json();
      setFaqPaquetes(data);
    }
  } catch (error) {
    console.error('Error cargando FAQ:', error);
  }
};

// ✅ Crear/Actualizar FAQ
const handleSubmitFAQ = async (e) => {
  e.preventDefault();
  
  try {
    const token = localStorage.getItem('token');
    const url = editingFAQ
      ? `${process.env.REACT_APP_API_URL}/faq-paquetes/${editingFAQ.id}`
      : `${process.env.REACT_APP_API_URL}/faq-paquetes`;
    
    const response = await fetch(url, {
      method: editingFAQ ? 'PUT' : 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        ...faqForm,
        activo: editingFAQ ? editingFAQ.activo : true
      })
    });
    
    if (response.ok) {
      await fetchFAQPaquetes();
      setFaqForm({ pregunta: '', respuesta: '', orden: 0 });
      setEditingFAQ(null);
      alert(editingFAQ ? 'FAQ actualizada' : 'FAQ creada');
    }
  } catch (error) {
    console.error('Error guardando FAQ:', error);
    alert('Error al guardar FAQ');
  }
};

// ✅ Eliminar FAQ
const handleEliminarFAQ = async (id) => {
  if (!window.confirm('¿Eliminar esta pregunta frecuente?')) return;
  
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_API_URL}/faq-paquetes/${id}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    
    if (response.ok) {
      await fetchFAQPaquetes();
      alert('FAQ eliminada');
    }
  } catch (error) {
    console.error('Error eliminando FAQ:', error);
    alert('Error al eliminar FAQ');
  }
};

// ✅ Toggle activo/inactivo
const toggleFAQActivo = async (faq) => {
  try {
    const token = localStorage.getItem('token');
    await fetch(`${process.env.REACT_APP_API_URL}/faq-paquetes/${faq.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ ...faq, activo: !faq.activo })
    });
    await fetchFAQPaquetes();
  } catch (error) {
    console.error('Error actualizando estado:', error);
  }
};



// ✅ CREAR NUEVO DESTAQUE
const handleCrearDestaque = async (e) => {
  e.preventDefault();
  
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_API_URL}/destaques`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(destaqueForm)
    });
    
    if (response.ok) {
      await fetchDestaques();
      setDestaqueForm({ nombre: '', descripcion: '', color: '#FF6B6B', icono: '🎉' });
      alert('Destaque creado exitosamente');
    }
  } catch (error) {
    console.error('Error creando destaque:', error);
    alert('Error al crear destaque');
  }
};

// ✅ ACTUALIZAR DESTAQUE
const handleActualizarDestaque = async (e) => {
  e.preventDefault();
  
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_API_URL}/destaques/${editingDestaque.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        ...destaqueForm,
        activo: editingDestaque.activo
      })
    });
    
    if (response.ok) {
      await fetchDestaques();
      setEditingDestaque(null);
      setDestaqueForm({ nombre: '', descripcion: '', color: '#FF6B6B', icono: '🎉' });
      alert('Destaque actualizado exitosamente');
    }
  } catch (error) {
    console.error('Error actualizando destaque:', error);
    alert('Error al actualizar destaque');
  }
};

// ✅ ELIMINAR DESTAQUE
const handleEliminarDestaque = async (destaqueId) => {
  if (!window.confirm('¿Estás seguro de eliminar este destaque?')) return;
  
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_API_URL}/destaques/${destaqueId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (response.ok) {
      await fetchDestaques();
      alert('Destaque eliminado');
    }
  } catch (error) {
    console.error('Error eliminando destaque:', error);
    alert('Error al eliminar destaque');
  }
};

// ✅ ASIGNAR DESTAQUES A PAQUETES SELECCIONADOS
const handleAsignarDestaques = async () => {
  if (paquetesSeleccionados.length === 0) {
    alert('Selecciona al menos un paquete');
    return;
  }
  
  if (destaquesSeleccionados.length === 0) {
    alert('Selecciona al menos un destaque');
    return;
  }
  
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_API_URL}/destaques/asignar`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        paqueteIds: paquetesSeleccionados,
        destaqueIds: destaquesSeleccionados
      })
    });
    
    if (response.ok) {
      alert(`Destaques asignados a ${paquetesSeleccionados.length} paquetes`);
      setShowAsignarDestaquesModal(false);
      setDestaquesSeleccionados([]);
      setPaquetesSeleccionados([]);
      await fetchPaquetes();
    }
  } catch (error) {
    console.error('Error asignando destaques:', error);
    alert('Error al asignar destaques');
  }
};


// Verificar token
  const verifyToken = async () => {
    const token = localStorage.getItem('token');
    console.log('Token almacenado:', token ? 'Presente' : 'No encontrado');
    
    if (!token) {
      console.log('No hay token en localStorage');
      return false;
    }
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/verify`, {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      console.log('Verificación de token - Status:', response.status);
      
      if (response.ok) {
        const data = await response.json();
        console.log('Token válido para usuario:', data.user);
        return true;
      } else {
        console.log('Token inválido, removiendo de localStorage');
        localStorage.removeItem('token');
        return false;
      }
    } catch (error) {
      console.error('Error verificando token:', error);
      localStorage.removeItem('token');
      return false;
    }
  };




  
  useEffect(() => {
    const initializeAdmin = async () => {
      console.log('Inicializando panel de admin...');
      
      const isValidToken = await verifyToken();
      if (!isValidToken) {
        console.log('Token no válido, redirigiendo al login');
        return;
      }
      
      fetchPaquetes();
      fetchSecciones();
      fetchPaquetesExternos();
      fetchPaginasCMS();
      fetchEstadoSincronizacion();
      fetchDestaques();
      fetchFAQPaquetes();

      // Actualizar estado cada minuto
      const intervalo = setInterval(fetchEstadoSincronizacion, 60000);
      return () => clearInterval(intervalo);
    };
    
    initializeAdmin();
  }, []);

  useEffect(() => {
  if (paquetes.length > 0) {
    const transportes = [...new Set(paquetes.map(p => p.transporte).filter(Boolean))].sort();
    const duraciones = [...new Set(paquetes.map(p => p.duracion).filter(Boolean))].sort();
    setOpcionesTransporte(transportes);
    setOpcionesDuracion(duraciones);
  }
}, [paquetes]);


const handleEditCMS = (pagina) => {
  console.log('Editando página CMS:', pagina);
  setEditingCMS(pagina);
  setCmsFormData({
    titulo: pagina.titulo,
    descripcion: pagina.descripcion,
    slug: pagina.slug,
    activo: pagina.activo !== undefined ? pagina.activo : true,
    secciones: pagina.secciones || []
  });
  setShowCMSForm(true);
};

const handleCMSInputChange = (e) => {
  const { name, value, type, checked } = e.target;
  setCmsFormData(prev => ({
    ...prev,
    [name]: type === 'checkbox' ? checked : value
  }));
};

const handleSeccionChange = (index, field, value) => {
  const nuevasSecciones = [...cmsFormData.secciones];
  nuevasSecciones[index][field] = value;
  setCmsFormData(prev => ({
    ...prev,
    secciones: nuevasSecciones
  }));
};

const agregarSeccion = () => {
  setCmsFormData(prev => ({
    ...prev,
    secciones: [...prev.secciones, { titulo: '', contenido: '', orden: prev.secciones.length }]
  }));
};

const eliminarSeccion = (index) => {
  const nuevasSecciones = cmsFormData.secciones.filter((_, i) => i !== index);
  setCmsFormData(prev => ({
    ...prev,
    secciones: nuevasSecciones
  }));
};

const handleSubmitCMS = async (e) => {
  e.preventDefault();
  
  console.log('=== ENVIANDO CMS ===');
  console.log('Datos a enviar:', cmsFormData);
  console.log('Página siendo editada:', editingCMS);
  
  try {
    const token = localStorage.getItem('token');
    const url = `${process.env.REACT_APP_API_URL}/paginas-cms/${editingCMS.id}`;
    
    const bodyData = {
      titulo: cmsFormData.titulo,
      descripcion: cmsFormData.descripcion,
      activo: cmsFormData.activo,
      secciones: cmsFormData.secciones
    };
    
    console.log('URL:', url);
    console.log('Body:', JSON.stringify(bodyData, null, 2));
    
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(bodyData)
    });
    
    console.log('Response status:', response.status);
    
    const data = await response.json();
    console.log('Response data:', data);
    
    if (response.ok) {
      await fetchPaginasCMS();
      setShowCMSForm(false);
      setEditingCMS(null);
      alert('Página actualizada exitosamente');
    } else {
      throw new Error(data.message || 'Error al actualizar página');
    }
  } catch (error) {
    console.error('Error completo:', error);
    alert(`Error al actualizar la página: ${error.message}`);
  }
};

const resetCMSForm = () => {
  setCmsFormData({
    titulo: '',
    descripcion: '',
    slug: '',
    activo: true,
    secciones: []
  });
  setEditingCMS(null);
  setShowCMSForm(false);
};

  const fetchSecciones = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/secciones-home`);
      if (response.ok) {
        const data = await response.json();
        console.log('Secciones fetched:', data);
        setSecciones(data);
      }
    } catch (err) {
      console.error('Error fetching secciones:', err);
    }
  };

const fetchPaquetesExternos = async () => {
  try {
    console.log('Fetching paquetes externos...');
    const response = await fetch(`${process.env.REACT_APP_API_URL}/paquetes-externos`);
    
    if (response.ok) {
      const data = await response.json();
      console.log('Respuesta completa API externa:', data);
      
      let paquetesArray = [];
      
      // La API devuelve { estado: 1, viajes: { "id": {...}, "id2": {...} } }
      if (data.estado === 1 && data.viajes) {
        if (Array.isArray(data.viajes)) {
          // Si ya es array (por si cambia la API)
          paquetesArray = data.viajes;
        } else if (typeof data.viajes === 'object') {
          // ✅ CONVERTIR OBJETO A ARRAY
          paquetesArray = Object.values(data.viajes);
          console.log(`✅ Objeto convertido a array: ${paquetesArray.length} viajes`);
        } else {
          console.warn('data.viajes tiene formato inesperado:', typeof data.viajes);
          paquetesArray = [];
        }
      } else if (Array.isArray(data)) {
        // Por si la respuesta ya es un array directamente
        paquetesArray = data;
      } else {
        console.warn('Formato de respuesta no reconocido');
        console.log('Tipo de data:', typeof data);
        console.log('Keys de data:', Object.keys(data));
        paquetesArray = [];
      }
      
      console.log(`📦 Paquetes externos procesados: ${paquetesArray.length}`);
      
      if (paquetesArray.length > 0) {
        console.log('=== PRIMER PAQUETE PARA DEBUG ===');
        console.log('ID:', paquetesArray[0].id);
        console.log('Destino:', paquetesArray[0].destino?.nombre);
        console.log('Tarifa:', paquetesArray[0].tarifa);
        console.log('Campos disponibles:', Object.keys(paquetesArray[0]));
        console.log('==================================');
      } else {
        console.warn('⚠️ No se encontraron paquetes externos');
      }
      
      setPaquetesExternos(paquetesArray);
      
    } else {
      console.error('❌ Error en respuesta API externa:', response.status);
      const errorText = await response.text();
      console.error('Respuesta de error:', errorText);
      setPaquetesExternos([]);
    }
  } catch (err) {
    console.error('❌ Error fetching paquetes externos:', err);
    setPaquetesExternos([]);
  } 
};


// ✅ AGREGAR DESPUÉS DE fetchPaquetes
const fetchDestaques = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/destaques`);
    if (response.ok) {
      const data = await response.json();
      setDestaques(data);
    }
  } catch (error) {
    console.error('Error cargando destaques:', error);
  }
};


// Función para obtener estado de sincronización
const fetchEstadoSincronizacion = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/estado-sincronizacion`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (response.ok) {
      const data = await response.json();
      setEstadoSincronizacion(data);
    }
  } catch (error) {
    console.error('Error obteniendo estado de sincronización:', error);
  }
};

// Función para sincronizar manualmente
const sincronizarManualmente = async () => {
  setSincronizando(true);
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/sincronizar-disponibilidad`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (response.ok) {
      alert('Sincronización completada exitosamente');
      await fetchPaquetes();
      await fetchEstadoSincronizacion();
    } else {
      throw new Error('Error en sincronización');
    }
  } catch (error) {
    console.error('Error sincronizando:', error);
    alert('Error al sincronizar');
  } finally {
    setSincronizando(false);
  }
};


// Función para verificar y reactivar paquetes agotados
const verificarReactivaciones = async () => {
  setVerificandoReactivaciones(true);
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/verificar-reactivaciones`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (response.ok) {
      const data = await response.json();
      alert(`✅ Verificación completada\n\n📦 Paquetes verificados: ${data.verificados}\n🟢 Reactivados: ${data.reactivados}`);
      await fetchPaquetes();
    } else {
      throw new Error('Error en verificación');
    }
  } catch (error) {
    console.error('Error verificando reactivaciones:', error);
    alert('Error al verificar reactivaciones');
  } finally {
    setVerificandoReactivaciones(false);
  }
};


const fetchPaginasCMS = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_API_URL}/paginas-cms`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (response.ok) {
      const data = await response.json();
      console.log('Páginas CMS fetched:', data);
      setPaginasCMS(data);
    }
  } catch (err) {
    console.error('Error fetching páginas CMS:', err);
  }
};

  // Fetch paquetes - ACTUALIZADO para usar ruta de admin
  const fetchPaquetes = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      console.log('Fetching paquetes de admin con token:', token ? 'Presente' : 'No encontrado');
      
      if (!token) {
        throw new Error('No hay token disponible');
      }
      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/paquetes`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      console.log('fetchPaquetes response status:', response.status);
      
      if (response.status === 401) {
        console.log('Token expirado/inválido, removiendo de localStorage');
        localStorage.removeItem('token');
        throw new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
      }
      
      if (response.ok) {
        const data = await response.json();
        console.log('Paquetes de admin fetched exitosamente:', data.length, 'paquetes');
        setPaquetes(data);
      } else {
        const errorText = await response.text();
        console.error('Error en fetchPaquetes:', response.status, errorText);
        throw new Error(`Error ${response.status}: ${errorText}`);
      }
    } catch (error) {
      console.error('Error al cargar paquetes:', error);
      alert(`Error al cargar paquetes: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  // Validación - ACTUALIZADA con campos PostgreSQL
  const validateForm = () => {
    const newErrors = {};
    if (!formData.titulo.trim()) newErrors.titulo = 'El título es obligatorio';
    //if (!formData.descripcion.trim()) newErrors.descripcion = 'La descripción es obligatoria';
    if (!formData.tarifa || formData.tarifa <= 0) newErrors.tarifa = 'La tarifa debe ser mayor a 0';
    if (!formData.destino.trim()) newErrors.destino = 'El destino es obligatorio';
    if (!formData.duracion.trim()) newErrors.duracion = 'La duración es obligatoria';
    if (!formData.fecha_salida) newErrors.fecha_salida = 'La fecha de salida es obligatoria';
    if (!formData.disponibilidad || formData.disponibilidad <= 0) newErrors.disponibilidad = 'La disponibilidad deben ser mayor a 0';
    setErrors(newErrors);
    console.log('Validación result:', Object.keys(newErrors).length === 0, 'Errors:', newErrors);
    return Object.keys(newErrors).length === 0;
  };


const handleSubmit = async (e) => {
  e.preventDefault();
  console.log('=== INICIANDO SUBMIT ===');
  console.log('FormData:', formData);
  console.log('EditingPaquete:', editingPaquete);
  
  if (!validateForm()) {
    console.log('Validación fallida');
    return;
  }
  
  // Validación adicional para paquetes programados
  if (formData.estado === 'programado') {
    if (!formData.fecha_publicacion || !formData.hora_publicacion) {
      alert('Para paquetes programados debe seleccionar fecha y hora de publicación');
      return;
    }
    
    const fechaHoraPublicacion = new Date(`${formData.fecha_publicacion}T${formData.hora_publicacion}`);
    const ahora = new Date();
    
    if (fechaHoraPublicacion < ahora) {
      alert('La fecha y hora de publicación no puede ser anterior al momento actual');
      return;
    }
    
    const diferenciaMinutos = (fechaHoraPublicacion - ahora) / (1000 * 60);
    if (diferenciaMinutos < 5) {
      const confirmar = window.confirm(
        `La publicación está programada para ${diferenciaMinutos.toFixed(1)} minutos. ¿Continuar?`
      );
      if (!confirmar) return;
    }
  }
  
  setLoading(true);
  try {
    const token = localStorage.getItem('token');
    console.log('Token para submit:', token ? 'Presente' : 'No encontrado');
    
    if (!token) {
      throw new Error('No hay token de autenticación. Por favor, inicia sesión.');
    }
    
    const url = editingPaquete
      ? `${process.env.REACT_APP_API_URL}/paquetes/${editingPaquete.id}`
      : `${process.env.REACT_APP_API_URL}/paquetes`;
    const method = editingPaquete ? 'PUT' : 'POST';
    
    console.log('Enviando a:', url);
    console.log('Método:', method);
    
    // Body con campos de PostgreSQL
    const bodyData = {
      titulo: formData.titulo,
      descripcion: formData.descripcion,
      tarifa: parseFloat(formData.tarifa),
      moneda: formData.moneda,
      descuento_principal_monto: formData.descuento_principal_monto ? parseFloat(formData.descuento_principal_monto) : 0,
      categoria: formData.categoria,
      duracion: formData.duracion,
      fecha_salida: formData.fecha_salida,
      disponibilidad: parseInt(formData.disponibilidad) || 0,
      estado: formData.estado,
      destacado: formData.destacado,
      home_section: formData.home_section || null,
      fecha_publicacion: formData.estado === 'programado' ? formData.fecha_publicacion : null,
      hora_publicacion: formData.estado === 'programado' ? formData.hora_publicacion : null,
      hotel: formData.hotel,
      transporte: formData.transporte || '',
      regimen: formData.regimen || '',
      singles: formData.singles || '',
      incluye_coordinador: formData.incluye_coordinador || false,
      incluye_transfer: formData.incluye_transfer || false,
      // ⚠️ CAMPOS DE DESTINO (ambos son necesarios):
      destino_id: formData.destino_id || null,
      destino_nombre: formData.destino_nombre || formData.destino || ''
    };
    
    console.log('Body enviado:', JSON.stringify(bodyData, null, 2));
    
    const response = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(bodyData)
    });
    
    console.log('Response status:', response.status);
    console.log('Response headers:', Object.fromEntries(response.headers.entries()));
    
    // ⚠️ CAPTURAR RESPUESTA COMPLETA (incluso si hay error)
    const responseText = await response.text();
    console.log('Response text:', responseText);
    
    let data;
    try {
      data = JSON.parse(responseText);
      console.log('Response data:', data);
    } catch (parseError) {
      console.error('Error parseando JSON:', parseError);
      throw new Error(`Respuesta no es JSON válido: ${responseText.substring(0, 200)}`);
    }
    
    if (response.status === 401) {
      console.log('Error 401 - Token inválido/expirado');
      localStorage.removeItem('token');
      throw new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
    }
    
    if (response.ok) {
      console.log('Paquete guardado exitosamente');
      
      // ============================================
      // ACTUALIZAR SECCIÓN SI SE SELECCIONÓ
      // ============================================
      const paqueteId = editingPaquete ? editingPaquete.id : data.paquete?.id || data.id;
      const seccionSeleccionada = formData.home_section ? parseInt(formData.home_section) : null;
      const seccionAnterior = editingPaquete?.home_section ? parseInt(editingPaquete.home_section) : null;
      
      console.log('Actualizando secciones...');
      console.log('Paquete ID:', paqueteId);
      console.log('Sección seleccionada:', seccionSeleccionada);
      console.log('Sección anterior:', seccionAnterior);
      
      // 1. Remover de la sección anterior si existía
      if (seccionAnterior && seccionAnterior !== seccionSeleccionada) {
        const seccionAnteriorData = secciones.find(s => s.id === seccionAnterior);
        if (seccionAnteriorData) {
          const nuevosPaquetesIds = (seccionAnteriorData.paquetesIds || []).filter(id => id !== paqueteId);
          
          await fetch(`${process.env.REACT_APP_API_URL}/secciones-home/${seccionAnterior}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ paquetesIds: nuevosPaquetesIds })
          });
          console.log(`Removido de sección ${seccionAnterior}`);
        }
      }
      
      // 2. Agregar a la nueva sección si se seleccionó una
      if (seccionSeleccionada && paqueteId) {
        const seccionData = secciones.find(s => s.id === seccionSeleccionada);
        if (seccionData) {
          const paquetesIdsActuales = seccionData.paquetesIds || [];
          
          // Solo agregar si no existe ya
          if (!paquetesIdsActuales.includes(paqueteId)) {
            const nuevosPaquetesIds = [...paquetesIdsActuales, paqueteId];
            
            const updateResponse = await fetch(`${process.env.REACT_APP_API_URL}/secciones-home/${seccionSeleccionada}`, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify({ paquetesIds: nuevosPaquetesIds })
            });
            
            if (updateResponse.ok) {
              console.log(`✅ Agregado a sección ${seccionSeleccionada}`);
            } else {
              const errorText = await updateResponse.text();
              console.error('Error al actualizar sección:', errorText);
            }
          } else {
            console.log('Paquete ya existe en la sección');
          }
        }
      }
      
      // 3. Refrescar datos
      await fetchPaquetes();
      await fetchSecciones();
      resetForm();
      alert(data.message || (editingPaquete ? 'Paquete actualizado exitosamente' : 'Paquete creado exitosamente'));
    } else {
      // ⚠️ MOSTRAR ERROR DETALLADO
      const errorMessage = data.message || data.error || `Error ${response.status}`;
      console.error('Error del servidor:', {
        status: response.status,
        message: errorMessage,
        data: data
      });
      throw new Error(errorMessage);
    }
  } catch (error) {
    console.error('❌ Error en handleSubmit:', error);
    console.error('Error stack:', error.stack);
    alert(`Error al guardar el paquete: ${error.message}`);
  } finally {
    setLoading(false);
  }
};


const handleEdit = (paquete) => {
  console.log('Editando paquete:', paquete);
  setEditingPaquete(paquete);
  setFormData({
    titulo: paquete.titulo || '',
    descripcion: paquete.descripcion || '',
    tarifa: paquete.tarifa?.toString() || '',
    moneda: paquete.moneda || '$',
    descuento_principal_monto: paquete.descuento_principal_monto?.toString() || '',
    categoria: paquete.categoria || 'nacional',
    duracion: paquete.duracion || '',
    fecha_salida: paquete.fecha_salida ? paquete.fecha_salida.split('T')[0] : '',
    disponibilidad: paquete.disponibilidad?.toString() || '',
    estado: paquete.estado || 'activo',
    imagen: '',
    destacado: paquete.destacado || false,
    home_section: paquete.home_section?.toString() || '',
    fecha_publicacion: paquete.fecha_publicacion || '',
    hora_publicacion: paquete.hora_publicacion || '',
    hotel: paquete.hotel || '',
    transporte: paquete.transporte || '',
    regimen: paquete.regimen || '',
    singles: paquete.singles || '',
    incluye: '',
    noIncluye: '',
    destino: paquete.destino_nombre || '', // ← Mostrar en input
    destino_id: paquete.destino_id || null, // ← NUEVO
    destino_nombre: paquete.destino_nombre || '', // ← NUEVO
    fecha_regreso: '',
    incluye_transfer: paquete.incluye_transfer !== undefined ? paquete.incluye_transfer : false,
    incluye_coordinador: paquete.incluye_coordinador || false
  });
  setShowForm(true);
};

const handleDelete = async (id) => {
  if (!window.confirm('¿Estás seguro de que quieres eliminar este paquete?')) return;
  setLoading(true);
  try {
    const paquete = paquetes.find(p => p.id === id);
    
    const response = await fetch(`${process.env.REACT_APP_API_URL}/paquetes/${id}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
    
    if (response.ok) {
      // Remover de sección si estaba asignado
      if (paquete?.home_section) {
        const seccion = secciones.find(s => s.id === parseInt(paquete.home_section));
        if (seccion) {
          const nuevosPaquetesIds = (seccion.paquetesIds || []).filter(pId => pId !== id);
          await fetch(`${process.env.REACT_APP_API_URL}/secciones-home/${paquete.home_section}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({ paquetesIds: nuevosPaquetesIds })
          });
        }
      }
      
      await fetchPaquetes();
      await fetchSecciones();
      alert('Paquete eliminado exitosamente');
    } else {
      throw new Error(await response.text());
    }
  } catch (error) {
    console.error('Error:', error);
    alert('Error al eliminar el paquete');
  } finally {
    setLoading(false);
  }
};

  const resetForm = () => {
  setFormData({
    titulo: '',
    descripcion: '',
    tarifa: '',
    moneda: '$',
    descuento_principal_monto: '',
    categoria: 'nacional',
    incluye_coordinador: false,
    incluye_transfer: false,
    destino: '',
    destino_id: null, // ← NUEVO
    destino_nombre: '', // ← NUEVO
    duracion: '',
    incluye: '',
    noIncluye: '',
    fecha_salida: '',
    fecha_regreso: '',
    disponibilidad: '',
    estado: 'activo',
    imagen: '',
    destacado: false,
    home_section: '',
    fecha_publicacion: '',
    hora_publicacion: '',
    hotel: ''
  });
  setEditingPaquete(null);
  setShowForm(false);
  setErrors({});
};


const handlePrecargarExterno = (paqueteExterno) => {
  if (!paqueteExterno) return;

  console.log('Paquete seleccionado:', paqueteExterno);
  
  const titulo = paqueteExterno.destino?.nombre || '';
  const tarifa = paqueteExterno.tarifa || '';
  const destino = paqueteExterno.destino?.nombre || '';
  const destinoId = paqueteExterno.destino?.id || null; // ← CAPTURAR ID
  const hotel = paqueteExterno.hotel || '';
  const duracion = paqueteExterno.duracion || '';
  const fechaSalida = paqueteExterno.fecha_de_salida || '';
  const disponibilidad = paqueteExterno.disponibilidad || '';
  const monedaAPI = paqueteExterno.moneda || '$';
  
  let incluye = [];
  if (paqueteExterno.transporte) incluye.push(`Transporte: ${paqueteExterno.transporte}`);
  if (paqueteExterno.regimen) incluye.push(`Régimen: ${paqueteExterno.regimen}`);
  if (hotel) incluye.push(`Alojamiento: ${hotel}`);
  
  setFormData(prev => ({
    ...prev,
    titulo: titulo,
    tarifa: tarifa.toString(),
    moneda: monedaAPI === 'U$S' || monedaAPI === 'USD' ? 'U$S' : '$',
    destino: destino, // ← Mantener por compatibilidad con el input
    destino_id: destinoId, // ← NUEVO: Guardar el ID
    destino_nombre: destino, // ← NUEVO: Guardar el nombre
    duracion: duracion,
    descripcion: paqueteExterno.descripcion?.replace(/\\u003C/g, '<').replace(/\\u003E/g, '>') || '',
    incluye: incluye.join(', '),
    categoria: paqueteExterno.transporte === 'Aéreo' ? 'internacional' : 'nacional',
    hotel: hotel,
    fecha_salida: fechaSalida,
    disponibilidad: disponibilidad.toString(),
    transporte: paqueteExterno.transporte || '',
    regimen: paqueteExterno.regimen || '',
    // ✅ MANTENER valores que el usuario ya configuró
    incluye_coordinador: prev.incluye_coordinador,
    incluye_transfer: prev.incluye_transfer,
    destacado: prev.destacado,
    estado: prev.estado,
    home_section: prev.home_section
  }));

  console.log('✅ Datos cargados:', {
    titulo,
    destino_id: destinoId,
    destino_nombre: destino
  });
};

const toggleFiltro = (tipo, valor) => {
  setFiltrosActivos(prev => {
    const actual = prev[tipo] || [];
    const nuevoArray = actual.includes(valor)
      ? actual.filter(v => v !== valor)
      : [...actual, valor];
    return { ...prev, [tipo]: nuevoArray };
  });
};

const limpiarFiltros = () => {
  setFiltrosActivos({
    transporte: [],
    duracion: [],
    precioMin: null,
    precioMax: null,
    fechaMin: null,
    fechaMax: null,
    disponibilidadMin: null,
    disponibilidadMax: null,
    estado: ['activo'] // ← Volver a solo activos
  });
};

const aplicarFiltros = (paquetesBase) => {
  let filtrados = paquetesBase;

  // Filtro por estado (por defecto solo activos)
  if (filtrosActivos.estado && filtrosActivos.estado.length > 0) {
    filtrados = filtrados.filter(p => filtrosActivos.estado.includes(p.estado));
  }

  if (filtrosActivos.transporte.length > 0) {
    filtrados = filtrados.filter(p => filtrosActivos.transporte.includes(p.transporte));
  }

  if (filtrosActivos.duracion.length > 0) {
    filtrados = filtrados.filter(p => filtrosActivos.duracion.includes(p.duracion));
  }

  if (filtrosActivos.precioMin !== null) {
    filtrados = filtrados.filter(p => parseFloat(p.tarifa) >= filtrosActivos.precioMin);
  }
  if (filtrosActivos.precioMax !== null) {
    filtrados = filtrados.filter(p => parseFloat(p.tarifa) <= filtrosActivos.precioMax);
  }

  if (filtrosActivos.fechaMin) {
    filtrados = filtrados.filter(p => {
      const fecha = new Date(p.fecha_salida);
      return fecha >= new Date(filtrosActivos.fechaMin);
    });
  }
  if (filtrosActivos.fechaMax) {
    filtrados = filtrados.filter(p => {
      const fecha = new Date(p.fecha_salida);
      return fecha <= new Date(filtrosActivos.fechaMax);
    });
  }

  if (filtrosActivos.disponibilidadMin !== null) {
    filtrados = filtrados.filter(p => p.disponibilidad >= filtrosActivos.disponibilidadMin);
  }
  if (filtrosActivos.disponibilidadMax !== null) {
    filtrados = filtrados.filter(p => p.disponibilidad <= filtrosActivos.disponibilidadMax);
  }

  return filtrados;
};

// COMPONENTE PARA FILTRO POR COLUMNA
const FiltroColumna = ({ columna, tipo }) => {
  const [mostrar, setMostrar] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setMostrar(!mostrar)}
        className={`px-2 py-1 rounded text-sm transition-colors ${
          (filtrosActivos[tipo]?.length > 0 || 
           filtrosActivos[`${tipo}Min`] !== null || 
           filtrosActivos[`${tipo}Max`] !== null)
            ? 'bg-blue-100 text-blue-700 border border-blue-300'
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        }`}
        title={`Filtrar por ${columna}`}
      >
        ⚙️ {columna}
        {(filtrosActivos[tipo]?.length > 0 || 
          filtrosActivos[`${tipo}Min`] !== null || 
          filtrosActivos[`${tipo}Max`] !== null) && (
          <span className="ml-1 font-bold">✓</span>
        )}
      </button>

      {mostrar && (
        <div className="absolute top-full right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg z-20 min-w-[280px]">
          {tipo === 'transporte' && (
            <div className="p-3 space-y-2">
              <h4 className="font-semibold text-sm mb-3">Filtrar por Transporte</h4>
              {opcionesTransporte.map(transporte => (
                <label key={transporte} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={filtrosActivos.transporte.includes(transporte)}
                    onChange={() => toggleFiltro('transporte', transporte)}
                    className="rounded"
                  />
                  <span className="text-sm">{transporte}</span>
                </label>
              ))}
            </div>
          )}

          {tipo === 'duracion' && (
            <div className="p-3 space-y-2">
              <h4 className="font-semibold text-sm mb-3">Filtrar por Duración</h4>
              {opcionesDuracion.map(duracion => (
                <label key={duracion} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={filtrosActivos.duracion.includes(duracion)}
                    onChange={() => toggleFiltro('duracion', duracion)}
                    className="rounded"
                  />
                  <span className="text-sm">{duracion}</span>
                </label>
              ))}
            </div>
          )}

          {tipo === 'precio' && (
            <div className="p-3 space-y-3">
              <h4 className="font-semibold text-sm mb-3">Filtrar por Precio</h4>
              <div>
                <label className="text-xs font-medium text-gray-700 mb-1 block">Precio Mínimo</label>
                <input
                  type="number"
                  value={filtrosActivos.precioMin || ''}
                  onChange={(e) => setFiltrosActivos(prev => ({
                    ...prev,
                    precioMin: e.target.value ? parseInt(e.target.value) : null
                  }))}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                  placeholder="Min"
                />
              </div>
              <div>
                <label className="text-xs font-medium text-gray-700 mb-1 block">Precio Máximo</label>
                <input
                  type="number"
                  value={filtrosActivos.precioMax || ''}
                  onChange={(e) => setFiltrosActivos(prev => ({
                    ...prev,
                    precioMax: e.target.value ? parseInt(e.target.value) : null
                  }))}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                  placeholder="Max"
                />
              </div>
            </div>
          )}

          {tipo === 'fecha' && (
            <div 
              className="p-3 space-y-3"
              onClick={(e) => e.stopPropagation()}
            >
              <h4 className="font-semibold text-sm mb-3">Filtrar por Fecha</h4>
              <div>
                <label className="text-xs font-medium text-gray-700 mb-1 block">Desde</label>
                <input
                  type="date"
                  value={filtrosActivos.fechaMin || ''}
                  onChange={(e) => {
                    e.stopPropagation();
                    setFiltrosActivos(prev => ({
                      ...prev,
                      fechaMin: e.target.value
                    }));
                  }}
                  onClick={(e) => e.stopPropagation()}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                />
              </div>
              <div>
                <label className="text-xs font-medium text-gray-700 mb-1 block">Hasta</label>
                <input
                  type="date"
                  value={filtrosActivos.fechaMax || ''}
                  onChange={(e) => {
                    e.stopPropagation();
                    setFiltrosActivos(prev => ({
                      ...prev,
                      fechaMax: e.target.value
                    }));
                  }}
                  onClick={(e) => e.stopPropagation()}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                />
              </div>
            </div>
          )}

          {tipo === 'disponibilidad' && (
            <div className="p-3 space-y-3">
              <h4 className="font-semibold text-sm mb-3">Filtrar por Disponibilidad</h4>
              <div>
                <label className="text-xs font-medium text-gray-700 mb-1 block">Mínimo</label>
                <input
                  type="number"
                  value={filtrosActivos.disponibilidadMin || ''}
                  onChange={(e) => setFiltrosActivos(prev => ({
                    ...prev,
                    disponibilidadMin: e.target.value ? parseInt(e.target.value) : null
                  }))}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                  placeholder="Min"
                  min="0"
                />
              </div>
              <div>
                <label className="text-xs font-medium text-gray-700 mb-1 block">Máximo</label>
                <input
                  type="number"
                  value={filtrosActivos.disponibilidadMax || ''}
                  onChange={(e) => setFiltrosActivos(prev => ({
                    ...prev,
                    disponibilidadMax: e.target.value ? parseInt(e.target.value) : null
                  }))}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                  placeholder="Max"
                  min="0"
                />
              </div>
            </div>
          )}

          <div className="border-t p-2 flex gap-2">
            <button
              onClick={() => setMostrar(false)}
              className="flex-1 text-xs px-2 py-1 bg-gray-200 rounded hover:bg-gray-300"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};


// Función para obtener label del estado
  const getEstadoLabel = (estado) => {
    switch (estado) {
      case 'activo': return 'Activo';
      case 'inactivo': return 'Inactivo';
      case 'programado': return 'Programado';
      case 'agotado': return 'Agotado';
      default: return estado;
    }
  };

  // Función para obtener color del estado
  const getEstadoColor = (estado) => {
    switch (estado) {
      case 'activo': return 'bg-green-100 text-green-800';
      case 'inactivo': return 'bg-gray-100 text-gray-800';
      case 'programado': return 'bg-blue-100 text-blue-800';
      case 'agotado': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  // Función para formatear fecha y hora de publicación
  const formatearFechaPublicacion = (paquete) => {
    if (paquete.estado === 'programado' && paquete.fecha_publicacion && paquete.hora_publicacion) {
      const fecha = new Date(`${paquete.fecha_publicacion}T${paquete.hora_publicacion}`);
      return fecha.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
    return '';
  };

  const DateTimeIndicator = ({ fechaPublicacion, horaPublicacion }) => {
    const [timeLeft, setTimeLeft] = useState('');
    
    useEffect(() => {
      const updateTimeLeft = () => {
        const fechaHoraPublicacion = new Date(`${fechaPublicacion}T${horaPublicacion}`);
        const ahora = new Date();
        const diferencia = fechaHoraPublicacion - ahora;
        
        if (diferencia < 0) {
          setTimeLeft('⚠️ Fecha/hora ya pasó');
          return;
        }
        
        const minutos = Math.floor(diferencia / (1000 * 60));
        const horas = Math.floor(minutos / 60);
        const dias = Math.floor(horas / 24);
        
        if (dias > 0) {
          setTimeLeft(`📅 Se publicará en ${dias} días y ${horas % 24} horas`);
        } else if (horas > 0) {
          setTimeLeft(`⏰ Se publicará en ${horas} horas y ${minutos % 60} minutos`);
        } else {
          setTimeLeft(`⚡ Se publicará en ${minutos} minutos`);
        }
      };
      
      updateTimeLeft();
      const interval = setInterval(updateTimeLeft, 60000);
      
      return () => clearInterval(interval);
    }, [fechaPublicacion, horaPublicacion]);
    
    return <span>{timeLeft}</span>;
  };

  // FUNCIÓN HELPER PARA RUTAS DE PÁGINAS
  // ============================================
  const getPageUrl = (slug) => {
    const specialPages = {
      'arrepentimiento': '/arrepentimiento',
      'preguntas-frecuentes': '/preguntas-frecuentes',
    };
    return specialPages[slug] || `/paginas/${slug}`;
  };

  if (user?.role !== 'admin') {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-lg text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Acceso Denegado</h2>
          <p>No tienes permisos para acceder a esta página.</p>
        </div>
      </div>
    );
  }


// Filtrar paquetes por búsqueda
const paquetesFiltrados = paquetes.filter(paquete => 
  paquete.titulo.toLowerCase().includes(busquedaPaquete.toLowerCase()) ||
  paquete.destino?.toLowerCase().includes(busquedaPaquete.toLowerCase()) ||
  paquete.hotel?.toLowerCase().includes(busquedaPaquete.toLowerCase())
);

// Calcular paginación
const totalPaginas = Math.ceil(paquetesFiltrados.length / PAQUETES_POR_PAGINA);
const indiceInicio = (paginaActual - 1) * PAQUETES_POR_PAGINA;
const indiceFin = indiceInicio + PAQUETES_POR_PAGINA;
const paquetesPaginados = paquetesFiltrados.slice(indiceInicio, indiceFin);

// Ordenar paquetes por fecha de salida (menor a mayor)
const ordenarPorFecha = (paquetes) => {
  return [...paquetes].sort((a, b) => {
    const fechaA = new Date(a.fecha_salida);
    const fechaB = new Date(b.fecha_salida);
    return fechaA - fechaB;
  });
};

const paquetesFiltradosConColumnas = ordenarPorFecha(aplicarFiltros(paquetesFiltrados));
const totalPaginasConFiltros = Math.ceil(paquetesFiltradosConColumnas.length / PAQUETES_POR_PAGINA);
const indiceInicioConFiltros = (paginaActual - 1) * PAQUETES_POR_PAGINA;
const indiceFinalConFiltros = indiceInicioConFiltros + PAQUETES_POR_PAGINA;
const paquetesPaginadosConFiltros = paquetesFiltradosConColumnas.slice(indiceInicioConFiltros, indiceFinalConFiltros);


return (
    <>
      <Helmet>
        <title>Panel de Administración | Noche y Día Turismo</title>
      </Helmet>
      
      <StandardNavbar />
      
      <div className="min-h-screen bg-gray-100 py-8">
        <div className="max-w-7xl mx-auto px-4">
          {/* Header */}
          <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
            <div className="flex justify-between items-center">
              <div>
                <h1 className="text-3xl font-bold text-gray-900">Panel de Administración</h1>
                <p className="text-gray-600 mt-1">Gestiona los paquetes de viaje</p>
              </div>

              <button
                onClick={() => setMostrarPanelSync(!mostrarPanelSync)}
                className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-colors"
              >
                🔄 Sincronización
              </button>

              <button
                onClick={() => setShowForm(!showForm)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-colors"
              >
                {showForm ? <X size={20} /> : <Plus size={20} />}
                {showForm ? 'Cancelar' : 'Nuevo Paquete'}
              </button>

              <button
                onClick={() => setShowDestaquesModal(true)}
                className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-colors"
              >
                🏷️ Gestionar Destaques
              </button>

            </div>
          </div>

          {/* Botón de sincronización */}
          <div className="mb-8">
            <SyncButton />
          </div>

          {/* ✅ AGREGAR ESTA NUEVA SECCIÓN AQUÍ */}
          <section className="bg-white rounded-lg shadow-lg mb-8">
            <ImageManager />
          </section>

          {/* Panel de Sincronización Automática */}
          {mostrarPanelSync && estadoSincronizacion && (
            <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
              <h3 className="text-xl font-bold mb-4">🔄 Sincronización Automática de Disponibilidad</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div className="p-4 bg-gray-50 rounded">
                  <span className="font-semibold">Estado:</span>
                  <span className={`ml-2 px-3 py-1 rounded ${estadoSincronizacion.activo ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                    {estadoSincronizacion.activo ? '✅ Activo' : '❌ Inactivo'}
                  </span>
                </div>
                
                <div className="p-4 bg-gray-50 rounded">
                  <span className="font-semibold">Última sincronización:</span>
                  <span className="ml-2">
                    {estadoSincronizacion.ultimaSincronizacion 
                      ? new Date(estadoSincronizacion.ultimaSincronizacion).toLocaleString('es-ES')
                      : 'Nunca'}
                  </span>
                </div>
                
                <div className="p-4 bg-gray-50 rounded">
                  <span className="font-semibold">Intervalo:</span>
                  <span className="ml-2">Cada {estadoSincronizacion.intervalo / 1000 / 60} minutos</span>
                </div>
                
                <div className="p-4 bg-gray-50 rounded">
                  <span className="font-semibold">Próxima sincronización:</span>
                  <span className="ml-2">
                    {estadoSincronizacion.proximaSincronizacion
                      ? new Date(estadoSincronizacion.proximaSincronizacion).toLocaleString('es-ES')
                      : 'N/A'}
                  </span>
                </div>
              </div>
              
              <div className="flex gap-3">
                <button
                  onClick={sincronizarManualmente}
                  disabled={sincronizando || verificandoReactivaciones}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg disabled:opacity-50"
                >
                  {sincronizando ? '⏳ Sincronizando...' : '🔄 Sincronizar Ahora'}
                </button>
                
                <button
                  onClick={verificarReactivaciones}
                  disabled={sincronizando || verificandoReactivaciones}
                  className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg disabled:opacity-50"
                  title="Verifica paquetes agotados que volvieron a tener disponibilidad"
                >
                  {verificandoReactivaciones ? '⏳ Verificando...' : '🟢 Verificar Agotados'}
                </button>
              </div>
            </div>

          )}

          {/* Formulario */}
          {showForm && (
            <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">
                {editingPaquete ? 'Editar Paquete' : 'Crear Nuevo Paquete'}
              </h2>
              
              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Select para precargar desde API externa */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Seleccionar desde API Externa
                  </label>
                  <SearchableSelect
                    options={paquetesExternos}
                    onSelect={handlePrecargarExterno}
                    placeholder="-- Buscar paquete por destino, hotel, o duración --"
                    className="w-full"
                    formatOption={(option) => {
                      if (!option) return 'Opción no válida';
                      
                      const destino = option.destino?.nombre || 'Sin destino';
                      const duracion = option.duracion || '';
                      const hotel = option.hotel || '';
                      const transporte = option.transporte || '';
                      
                      let precioTexto = '';
                      const moneda = option.moneda || '$';
                      const tarifa = option.tarifa || '';
                      
                      if (tarifa) {
                        if (moneda === 'U$S' || moneda === 'USD' || moneda === 'US$') {
                          precioTexto = `U$S ${tarifa}`;
                        } else {
                          precioTexto = `$${tarifa} ARS`;
                        }
                      }
                      
                      let display = destino;
                      if (duracion) display += ` (${duracion})`;
                      if (precioTexto) display += ` - ${precioTexto}`;
                      if (hotel && hotel !== 'Consultar hoteleria') display += ` | ${hotel}`;
                      if (transporte) display += ` [${transporte}]`;
                      
                      return display;
                    }}
                    formatSelected={(option) => {
                      if (!option) return '';
                      const destino = option.destino?.nombre || 'Sin destino';
                      const duracion = option.duracion || '';
                      return `${destino} ${duracion ? `(${duracion})` : ''}`;
                    }}
                    disabled={!Array.isArray(paquetesExternos) || paquetesExternos.length === 0}
                  />

                  <div className="mt-2 text-xs text-gray-500">
                    {Array.isArray(paquetesExternos) ? 
                      `${paquetesExternos.length} paquetes disponibles` : 
                      'Cargando paquetes externos...'
                    }
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Título */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Título del Paquete *
                    </label>
                    <input
                      type="text"
                      name="titulo"
                      value={formData.titulo}
                      onChange={handleInputChange}
                      className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.titulo ? 'border-red-500' : 'border-gray-300'}`}
                      placeholder="Ej: Paquete a Bariloche 3 días"
                    />
                    {errors.titulo && <p className="text-red-500 text-sm mt-1">{errors.titulo}</p>}
                  </div>

                  {/* Destino */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Destino *
                    </label>
                    <input
                      type="text"
                      name="destino"
                      value={formData.destino}
                      onChange={handleInputChange}
                      className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.destino ? 'border-red-500' : 'border-gray-300'}`}
                      placeholder="Ej: Bariloche, Argentina"
                    />
                    {errors.destino && <p className="text-red-500 text-sm mt-1">{errors.destino}</p>}
                  </div>

                  {/* Hotel */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Hotel
                    </label>
                    <input
                      type="text"
                      name="hotel"
                      value={formData.hotel}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Ej: Hotel Libertador Bariloche"
                    />
                  </div>

                  {/* NUEVOS CAMPOS - Detalles del viaje 
                  <div className="col-span-2 border-t pt-6 mt-6">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4">
                      Detalles del viaje
                    </h3>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {/* Transporte 
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Transporte
                        </label>
                        <input
                          type="text"
                          name="transporte"
                          value={formData.transporte}
                          onChange={handleInputChange}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          placeholder="Ej: Bus Semi-Cama, Aéreo, Auto"
                        />
                        <p className="text-xs text-gray-500 mt-1">
                          Tipo de transporte incluido en el paquete
                        </p>
                      </div>

                      {/* Régimen alimenticio 
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Régimen alimenticio
                        </label>
                        <select
                          name="regimen_incluido"
                          value={formData.regimen_incluido}
                          onChange={handleInputChange}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        >
                          <option value="">Sin régimen especificado</option>
                          <option value="Desayuno">Desayuno</option>
                          <option value="Media Pensión">Media Pensión (Desayuno + Cena)</option>
                          <option value="Pensión Completa">Pensión Completa (Desayuno + Almuerzo + Cena)</option>
                          <option value="All Inclusive">All Inclusive</option>
                        </select>
                        <p className="text-xs text-gray-500 mt-1">
                          Comidas incluidas en el hotel
                        </p>
                      </div>

                      {/* Incluye Coordinador - Checkbox 
                      <div className="col-span-2 flex items-start">
                        <input
                          type="checkbox"
                          name="incluye_coordinador"
                          id="incluye_coordinador"
                          checked={formData.incluye_coordinador}
                          onChange={handleInputChange}
                          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded mt-1"
                        />
                        <label htmlFor="incluye_coordinador" className="ml-3 text-sm">
                          <span className="font-medium text-gray-700">Incluye Coordinador</span>
                          <p className="text-gray-500">
                            Marcar si el paquete incluye servicio de coordinador durante el viaje
                          </p>
                        </label>
                      </div>
                    </div>
                  </div>*/}

                  {/* Tarifa (ACTUALIZADO) */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Tarifa *
                    </label>
                    <div className="flex gap-2">
                      <input
                        type="number"
                        name="tarifa"
                        value={formData.tarifa}
                        onChange={handleInputChange}
                        className={`flex-1 px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.tarifa ? 'border-red-500' : 'border-gray-300'}`}
                        placeholder="0"
                        min="0"
                        step="0.01"
                      />
                      <select
                        name="moneda"
                        value={formData.moneda}
                        onChange={handleInputChange}
                        className="px-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="$">$ ARS</option>
                        <option value="U$S">U$S</option>
                      </select>
                    </div>
                    {errors.tarifa && <p className="text-red-500 text-sm mt-1">{errors.tarifa}</p>}
                  </div>

                  {/* Descuento (ACTUALIZADO) */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Descuento (%)
                    </label>
                    <input
                      type="number"
                      name="descuento_principal_monto"
                      value={formData.descuento_principal_monto}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="0"
                      min="0"
                      max="100"
                    />
                  </div>

                  {/* Categoría */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Categoría
                    </label>
                    <select
                      name="categoria"
                      value={formData.categoria}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                      <option value="nacional">Nacional</option>
                      <option value="internacional">Internacional</option>
                      <option value="europa">Europa</option>
                      <option value="cruceros">Cruceros</option>
                    </select>
                  </div>

                  {/* Duración */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Duración *
                    </label>
                    <input
                      type="text"
                      name="duracion"
                      value={formData.duracion}
                      onChange={handleInputChange}
                      className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.duracion ? 'border-red-500' : 'border-gray-300'}`}
                      placeholder="Ej: 3 días / 2 noches"
                    />
                    {errors.duracion && <p className="text-red-500 text-sm mt-1">{errors.duracion}</p>}
                  </div>

                  {/* Fecha Salida (ACTUALIZADO) */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Fecha de Salida *
                    </label>
                    <input
                      type="date"
                      name="fecha_salida"
                      value={formData.fecha_salida}
                      onChange={handleInputChange}
                      className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.fecha_salida ? 'border-red-500' : 'border-gray-300'}`}
                    />
                    {errors.fecha_salida && <p className="text-red-500 text-sm mt-1">{errors.fecha_salida}</p>}
                  </div>

                  {/* Fecha Regreso (ACTUALIZADO) */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Fecha de Regreso
                    </label>
                    <input
                      type="date"
                      name="fecha_regreso"
                      value={formData.fecha_regreso}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>

                  {/* disponibilidad */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Cupos Disponibles *
                    </label>
                    <input
                      type="number"
                      name="disponibilidad"
                      value={formData.disponibilidad}
                      onChange={handleInputChange}
                      className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.disponibilidad ? 'border-red-500' : 'border-gray-300'}`}
                      placeholder="0"
                      min="1"
                    />
                    {errors.disponibilidad && <p className="text-red-500 text-sm mt-1">{errors.disponibilidad}</p>}
                  </div>

                  {/* URL Imagen */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      URL de Imagen
                    </label>
                    <input
                      type="url"
                      name="imagen"
                      value={formData.imagen}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="https://ejemplo.com/imagen.jpg"
                    />
                  </div>
                </div>

                {/* Estado */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
                  <select
                    name="estado"
                    value={formData.estado}
                    onChange={handleInputChange}
                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="activo">Activo</option>
                    <option value="inactivo">Inactivo</option>
                    <option value="programado">Programado</option>
                    <option value="agotado">Agotado</option>
                  </select>
                </div>

                {/* Campos de programación (ACTUALIZADO) */}
                {formData.estado === 'programado' && (
                  <div className="col-span-2 p-4 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-lg font-medium text-blue-800 mb-3">⏰ Programación de Publicación</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Fecha de Publicación *
                        </label>
                        <input
                          type="date"
                          name="fecha_publicacion"
                          value={formData.fecha_publicacion}
                          onChange={handleInputChange}
                          min={new Date().toISOString().split('T')[0]}
                          className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Hora de Publicación *
                        </label>
                        <input
                          type="time"
                          name="hora_publicacion"
                          value={formData.hora_publicacion}
                          onChange={handleInputChange}
                          className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                          required
                        />
                      </div>
                    </div>
                    
                    {formData.fecha_publicacion && formData.hora_publicacion && (
                      <div className="mt-3 p-2 bg-blue-100 rounded text-sm">
                        <DateTimeIndicator 
                          fechaPublicacion={formData.fecha_publicacion}
                          horaPublicacion={formData.hora_publicacion}
                        />
                      </div>
                    )}
                    
                    <p className="text-sm text-blue-600 mt-2">
                      ℹ️ El paquete se publicará automáticamente en la fecha y hora seleccionada.
                      Puede programarse para hoy mismo.
                    </p>
                  </div>
                )}

                {/* Descripción */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Descripción
                  </label>
                  <textarea
                    name="descripcion"
                    value={formData.descripcion}
                    onChange={handleInputChange}
                    rows={4}
                    className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.descripcion ? 'border-red-500' : 'border-gray-300'}`}
                    placeholder="Describe el paquete de viaje..."
                  />
                  {errors.descripcion && <p className="text-red-500 text-sm mt-1">{errors.descripcion}</p>}
                </div>

                {/* Incluye */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Qué Incluye
                  </label>
                  <textarea
                    name="incluye"
                    value={formData.incluye}
                    onChange={handleInputChange}
                    rows={3}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Ej: Alojamiento, desayuno, traslados..."
                  />
                </div>

                {/* No Incluye */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Qué NO Incluye
                  </label>
                  <textarea
                    name="noIncluye"
                    value={formData.noIncluye}
                    onChange={handleInputChange}
                    rows={3}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Ej: Vuelos, comidas no mencionadas..."
                  />
                </div>

                {/* Checkboxes y selects */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name="destacado"
                      id="destacado"
                      checked={formData.destacado}
                      onChange={handleInputChange}
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <label htmlFor="destacado" className="ml-2 text-sm text-gray-700">
                      Paquete Destacado
                    </label>
                  </div>


                {/* NUEVO: Incluye Coordinador */}
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    name="incluye_coordinador"
                    id="incluye_coordinador"
                    checked={formData.incluye_coordinador}
                    onChange={handleInputChange}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <label htmlFor="incluye_coordinador" className="ml-2 text-sm text-gray-700">
                    Incluye Coordinador
                  </label>
                </div>

                {/* Transfer (solo si es aéreo) */}
                {formData.categoria === 'internacional' && (
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name="incluye_transfer"
                      id="incluye_transfer"
                      checked={formData.incluye_transfer || false}
                      onChange={handleInputChange}
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <label htmlFor="incluye_transfer" className="ml-2 text-sm text-gray-700">
                      Incluye Transfer (In/Out aeropuerto)
                    </label>
                  </div>
                )}

                  {/* Sección en Home (ACTUALIZADO) */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Sección en Home
                    </label>
                    <select
                      name="home_section"
                      value={formData.home_section}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                      <option value="">-- Ninguna --</option>
                      {secciones.map(s => (
                        <option key={s.id} value={s.id.toString()}>
                          {s.titulo} ({s.paquetesIds?.length || 0} paquetes)
                        </option>
                      ))}
                    </select>
                    <p className="text-xs text-gray-500 mt-1">
                      Solo se mostrará en el home si el paquete está activo
                    </p>
                  </div>
                </div>

                {/* Botones */}
                <div className="flex justify-end space-x-4 pt-6 border-t">
                  <button
                    type="button"
                    onClick={resetForm}
                    className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    disabled={submitLoading || loading}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg flex items-center gap-2 transition-colors disabled:opacity-50"
                  >
                    <Save size={20} />
                    {submitLoading ? 'Guardando...' : (editingPaquete ? 'Actualizar' : 'Crear Paquete')}
                  </button>
                </div>
              </form>
            </div>
          )}

          {/* Lista de Paquetes */}
          <div className="bg-white rounded-lg shadow-lg">
            <div className="px-6 py-4 border-b border-gray-200">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-gray-900">
                  Paquetes Registrados ({paquetesFiltrados.length})
                </h3>
              </div>

              {/* Filtro de Estado */}
              <div className="flex items-center gap-4 mb-4">
                <span className="text-sm font-medium text-gray-700">Mostrar:</span>
                <div className="flex gap-2 flex-wrap">
                  <button
                    onClick={() => setFiltrosActivos(prev => ({ ...prev, estado: ['activo'] }))}
                    className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
                      filtrosActivos.estado?.length === 1 && filtrosActivos.estado[0] === 'activo'
                        ? 'bg-green-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    ✅ Activos
                  </button>
                  <button
                    onClick={() => setFiltrosActivos(prev => ({ ...prev, estado: ['inactivo'] }))}
                    className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
                      filtrosActivos.estado?.length === 1 && filtrosActivos.estado[0] === 'inactivo'
                        ? 'bg-gray-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    ⬚ Inactivos
                  </button>
                  <button
                    onClick={() => setFiltrosActivos(prev => ({ ...prev, estado: ['agotado'] }))}
                    className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
                      filtrosActivos.estado?.length === 1 && filtrosActivos.estado[0] === 'agotado'
                        ? 'bg-red-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    🔴 Agotados
                  </button>
                  <button
                    onClick={() => setFiltrosActivos(prev => ({ ...prev, estado: ['programado'] }))}
                    className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
                      filtrosActivos.estado?.length === 1 && filtrosActivos.estado[0] === 'programado'
                        ? 'bg-blue-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    📅 Programados
                  </button>
                  <button
                    onClick={() => setFiltrosActivos(prev => ({ ...prev, estado: [] }))}
                    className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
                      !filtrosActivos.estado || filtrosActivos.estado.length === 0
                        ? 'bg-purple-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    📋 Todos
                  </button>
                </div>
              </div>
              
              {/* Buscador */}
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                <input
                  type="text"
                  placeholder="Buscar por título, destino o hotel..."
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                  value={busquedaPaquete}
                  onChange={(e) => {
                    setBusquedaPaquete(e.target.value);
                    setPaginaActual(1); // Reset a página 1 al buscar
                  }}
                />
              </div>

              {Object.values(filtrosActivos).some(v => 
                (Array.isArray(v) && v.length > 0) || v !== null
              ) && (
                <div className="mt-3 p-3 bg-blue-50 rounded-lg border border-blue-200">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-blue-800">
                      Filtros activos: {paquetesFiltradosConColumnas.length} de {paquetesFiltrados.length} paquetes
                    </span>
                    <button
                      onClick={limpiarFiltros}
                      className="text-sm text-blue-600 hover:text-blue-800 font-medium"
                    >
                      Limpiar todos
                    </button>
                  </div>
                </div>
              )}

              {/* Barra de acciones masivas */}
              {paquetesSeleccionados.length > 0 && (
                <div className="mt-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-blue-800">
                      {paquetesSeleccionados.length} de {paquetesFiltradosConColumnas.length} paquete(s) seleccionado(s)
                    </span>
                    <div className="flex gap-2">
                      <button
                        onClick={() => setShowAsignarDestaquesModal(true)}
                        className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 flex items-center gap-2"
                      >
                        🏷️ Destaques
                      </button>
                      <button
                        onClick={() => setShowEdicionMasiva(true)}
                        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                      >
                        Editar Seleccionados
                      </button>
                    </div>
                  </div>
                </div>
              )}

            </div>
            
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left">
                      <input
                        type="checkbox"
                        checked={paquetesSeleccionados.length === paquetesFiltradosConColumnas.length && paquetesFiltradosConColumnas.length > 0}
                        onChange={seleccionarTodos}
                        className="rounded border-gray-300"
                        title={`Seleccionar todos los ${paquetesFiltradosConColumnas.length} paquetes filtrados`}
                      />
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Paquete</th>
                    <th className="px-6 py-3 text-left">
                      <FiltroColumna columna="Precio" tipo="precio" />
                    </th>
                    <th className="px-6 py-3 text-left">
                      <FiltroColumna columna="Transporte" tipo="transporte" />
                    </th>
                    <th className="px-6 py-3 text-left">
                      <FiltroColumna columna="Duración" tipo="duracion" />
                    </th>
                    <th className="px-6 py-3 text-left">
                      <FiltroColumna columna="Fecha Salida" tipo="fecha" />
                    </th>
                    <th className="px-6 py-3 text-left">
                      <FiltroColumna columna="Disponibilidad" tipo="disponibilidad" />
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {paquetesPaginadosConFiltros.map((paquete) => (
                    <tr key={paquete.id} className="hover:bg-gray-50">
                      {/* Checkbox - COLUMNA SEPARADA */}
                      <td className="px-6 py-4">
                        <input
                          type="checkbox"
                          checked={paquetesSeleccionados.includes(paquete.id)}
                          onChange={() => toggleSeleccionPaquete(paquete.id)}
                          className="rounded border-gray-300"
                        />
                      </td>

                      {/* Paquete info */}
                      <td className="px-6 py-4">
                        <div className="flex items-center">
                          {paquete.imagen && (
                            <img src={paquete.imagen} alt={paquete.titulo} className="h-10 w-10 rounded-full mr-3 object-cover" />
                          )}
                          <div>
                            <div className="text-sm font-medium text-gray-900">{paquete.titulo}</div>
                            <div className="text-sm text-gray-500">{paquete.destino}</div>

                            {/* ✅ NUEVO: Mostrar destaques asignados */}
                            {paquete.destaques && Array.isArray(paquete.destaques) && paquete.destaques.length > 0 && (
                              <div className="flex gap-1 mt-1">
                                {paquete.destaques.map(destaque => (
                                  <span 
                                    key={destaque.id}
                                    className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold text-white"
                                    style={{ backgroundColor: destaque.color }}
                                    title={destaque.descripcion}
                                  >
                                    {destaque.icono} {destaque.nombre}
                                  </span>
                                ))}
                              </div>
                            )}
                            
                            {paquete.home_section && (
                              <div className="text-xs text-purple-600">
                                📋 Sección: {secciones.find(s => s.id === parseInt(paquete.home_section))?.titulo || `ID: ${paquete.home_section}`}
                              </div>
                            )}
                            
                            {paquete.estado === 'programado' && formatearFechaPublicacion(paquete) && (
                              <div className="text-xs text-blue-600">
                                📅 Publica: {formatearFechaPublicacion(paquete)}
                              </div>
                            )}
                          </div>
                        </div>
                      </td>

                      {/* Precio */}
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm">
                          <div className={`font-medium ${paquete.moneda === 'U$S' || paquete.moneda === 'USD' ? 'text-blue-600' : 'text-gray-900'}`}>
                            {paquete.moneda || '$'} {paquete.tarifa?.toLocaleString()}
                          </div>
                          
                          {paquete.descuento_principal_monto > 0 && (
                            <div className="text-sm text-green-600">-{paquete.descuento_principal_monto}%</div>
                          )}
                        </div>
                      </td>

                      {/* Categoría 
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                          paquete.categoria === 'nacional' ? 'bg-green-100 text-green-800' : 'bg-purple-100 text-purple-800'
                        }`}>
                          {paquete.categoria}
                        </span>
                      </td>

                      {/* Estado 
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getEstadoColor(paquete.estado)}`}>
                          {getEstadoLabel(paquete.estado)}
                        </span>
                      </td>
                          */}
                      {/* Transporte */}
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center gap-2">
                          {paquete.transporte === 'Aéreo' || paquete.transporte === 'Aereo' ? (
                            <span className="text-2xl" title="Aéreo">✈️</span>
                          ) : (
                            <span className="text-2xl" title={paquete.transporte || 'Bus'}>🚌</span>
                          )}
                          <span className="text-sm text-gray-600">
                            {paquete.transporte || 'Bus'}
                          </span>
                        </div>
                      </td>

                      {/* Duración */}
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="text-sm text-gray-900">
                          {paquete.duracion || '-'}
                        </span>
                      </td>

                      {/* Fecha Salida */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {paquete.fecha_salida ? new Date(paquete.fecha_salida).toLocaleDateString('es-ES') : '-'}
                      </td>

                      {/* Cupos */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {paquete.disponibilidad || paquete.disponibilidad}
                      </td>

                      {/* Acciones */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <button
                          onClick={() => handleEdit(paquete)}
                          className="text-blue-600 hover:text-blue-900 mr-4"
                        >
                          ✏️
                        </button>
                        <button
                          onClick={() => handleDelete(paquete.id)}
                          className="text-red-600 hover:text-red-900"
                        >
                          🗑️
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Paginación */}
            {totalPaginasConFiltros > 1 && (
              <div className="px-6 py-4 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
                <div className="text-sm text-gray-600">
                  Mostrando {indiceInicioConFiltros + 1} - {Math.min(indiceFinalConFiltros, paquetesFiltradosConColumnas.length)} de {paquetesFiltradosConColumnas.length} paquetes
                </div>
                <div className="flex gap-2 items-center flex-wrap justify-center">
                  <button
                    onClick={() => setPaginaActual(prev => Math.max(1, prev - 1))}
                    disabled={paginaActual === 1}
                    className="px-4 py-2 border border-gray-300 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                  >
                    Anterior
                  </button>
                  
                  <div className="flex gap-1">
                    {/* Primera página */}
                    <button
                      onClick={() => setPaginaActual(1)}
                      className={`px-4 py-2 rounded-lg ${
                        paginaActual === 1
                          ? 'bg-blue-600 text-white'
                          : 'border border-gray-300 hover:bg-gray-50'
                      }`}
                    >
                      1
                    </button>
                    
                    {/* Puntos suspensivos iniciales */}
                    {paginaActual > 3 && <span className="px-2 py-2">...</span>}
                    
                    {/* Páginas intermedias */}
                    {[...Array(totalPaginas)].map((_, i) => {
                      const pageNum = i + 1;
                      // Mostrar solo páginas cercanas a la actual
                      if (pageNum === 1 || pageNum === totalPaginas) return null;
                      if (pageNum < paginaActual - 1 || pageNum > paginaActual + 1) return null;
                      
                      return (
                        <button
                          key={pageNum}
                          onClick={() => setPaginaActual(pageNum)}
                          className={`px-4 py-2 rounded-lg ${
                            paginaActual === pageNum
                              ? 'bg-blue-600 text-white'
                              : 'border border-gray-300 hover:bg-gray-50'
                          }`}
                        >
                          {pageNum}
                        </button>
                      );
                    })}
                    
                    {/* Puntos suspensivos finales */}
                    {paginaActual < totalPaginas - 2 && <span className="px-2 py-2">...</span>}
                    
                    {/* Última página */}
                    {totalPaginas > 1 && (
                      <button
                        onClick={() => setPaginaActual(totalPaginas)}
                        className={`px-4 py-2 rounded-lg ${
                          paginaActual === totalPaginas
                            ? 'bg-blue-600 text-white'
                            : 'border border-gray-300 hover:bg-gray-50'
                        }`}
                      >
                        {totalPaginas}
                      </button>
                    )}
                  </div>
                  
                  <button
                    onClick={() => setPaginaActual(prev => Math.min(totalPaginas, prev + 1))}
                    disabled={paginaActual === totalPaginas}
                    className="px-4 py-2 border border-gray-300 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                  >
                    Siguiente
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Popup Promocional */}
          <CollapsibleSection
            title="Popup Promocional"
            icon="🎁"
            description="Configura un popup con imagen promocional para los visitantes"
            defaultOpen={false}
          >
            <AdminPopupPromo />
          </CollapsibleSection>


          {/* Gestión de Secciones */}
          <CollapsibleSection
            title="Gestión de Secciones en Home"
            icon="📋"
            description="Los paquetes solo aparecen en las secciones si están en estado 'activo'"
            badge={secciones.length > 0 ? `${secciones.length} secciones` : null}
            defaultOpen={false}
          >
            <GestionSeccionesHome 
              secciones={secciones}
              paquetes={paquetes}
              onUpdateSeccion={async (seccionId, data) => {
                const token = localStorage.getItem('token');
                
                try {
                  if (data.titulo !== undefined) {
                    await fetch(`${process.env.REACT_APP_API_URL}/secciones-home/${seccionId}`, {
                      method: 'PUT',
                      headers: { 
                        'Content-Type': 'application/json', 
                        'Authorization': `Bearer ${token}` 
                      },
                      body: JSON.stringify({ titulo: data.titulo })
                    });
                  }
                  
                  if (data.paquetesIds !== undefined) {
                    await fetch(`${process.env.REACT_APP_API_URL}/secciones-home/${seccionId}`, {
                      method: 'PUT',
                      headers: { 
                        'Content-Type': 'application/json', 
                        'Authorization': `Bearer ${token}` 
                      },
                      body: JSON.stringify({ paquetesIds: data.paquetesIds })
                    });
                  }
                  
                  await fetchSecciones();
                } catch (error) {
                  console.error('Error actualizando sección:', error);
                  alert('Error al actualizar la sección');
                }
              }}
            />
          </CollapsibleSection>

          <CollapsibleSection
            title="Gestión de Destaques"
            icon="🏷️"
            description="Asigna paquetes a cada destaque creado"
            badge={destaques.length > 0 ? `${destaques.length} destaques` : null}
            defaultOpen={false}
          >
            <GestionDestaques
              destaques={destaques}
              paquetes={paquetes}
              onUpdateDestaque={async (destaqueId, data) => {
                const token = localStorage.getItem('token');
                await fetch(`${process.env.REACT_APP_API_URL}/destaques/${destaqueId}`, {
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                  },
                  body: JSON.stringify(data)
                });
              }}
              onRefresh={async () => {
                await fetchPaquetes();
                await fetchDestaques();
              }}
            />
          </CollapsibleSection>

          <CollapsibleSection
            title="Promociones y Descuentos"
            icon="💰"
            description="Crea promociones y aplica descuentos masivamente a paquetes"
            defaultOpen={false}
          >
            <GestionPromociones 
              paquetes={paquetes}
              onRefresh={async () => {
                await fetchPaquetes();
              }}
            />
          </CollapsibleSection>

          <CollapsibleSection
          title="FAQ de Paquetes"
          icon="❓"
          description="Gestiona las preguntas frecuentes que aparecen en cada paquete"
          badge={faqPaquetes.length > 0 ? `${faqPaquetes.length} preguntas` : null}
          defaultOpen={false}
        >
          <div className="p-6">
            <button
              onClick={() => setShowFAQModal(true)}
              className="mb-4 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
            >
              <Plus size={20} />
              Nueva Pregunta
            </button>

            <div className="space-y-3">
              {faqPaquetes.map((faq, index) => (
                <div key={faq.id} className="border border-gray-200 rounded-lg p-4 bg-white">
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs font-semibold">
                          #{faq.orden}
                        </span>
                        <button
                          onClick={() => toggleFAQActivo(faq)}
                          className={`px-2 py-1 rounded text-xs font-semibold ${
                            faq.activo ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                          }`}
                        >
                          {faq.activo ? '● Activo' : '○ Inactivo'}
                        </button>
                      </div>
                      <h4 className="font-semibold text-gray-900 mb-2">{faq.pregunta}</h4>
                      <p className="text-sm text-gray-600">{faq.respuesta}</p>
                    </div>
                    <div className="flex gap-2 ml-4">
                      <button
                        onClick={() => {
                          setEditingFAQ(faq);
                          setFaqForm({
                            pregunta: faq.pregunta,
                            respuesta: faq.respuesta,
                            orden: faq.orden
                          });
                          setShowFAQModal(true);
                        }}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <Edit2 size={18} />
                      </button>
                      <button
                        onClick={() => handleEliminarFAQ(faq.id)}
                        className="text-red-600 hover:text-red-800"
                      >
                        <Trash2 size={18} />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </CollapsibleSection>


          <CollapsibleSection
          title="Gestión de Páginas CMS"
          icon="📄"
          description="Administra el contenido de páginas estáticas"
          badge={paginasCMS.length > 0 ? `${paginasCMS.length} páginas` : null}
          defaultOpen={false}
        >
          <div className="p-6">
            <div className="space-y-3">
              {paginasCMS.map(pagina => (
                <div key={pagina.id} className="p-4 bg-gray-50 rounded-lg flex justify-between items-center">
                  <div>
                    <h4 className="font-medium">{pagina.titulo}</h4>
                    <p className="text-sm text-gray-600">{pagina.descripcion}</p>
                    <p className="text-xs text-gray-500 mt-1">
                      Slug: /{pagina.slug} | {pagina.secciones.length} secciones
                    </p>
                  </div>
                  <div className="flex gap-2">
                    <button 
                      onClick={() => window.open(getPageUrl(pagina.slug), '_blank')}
                      className="text-blue-600 hover:text-blue-800 px-3 py-1 border border-blue-600 rounded"
                    >
                      👁️ Ver
                    </button>
                    <button 
                      onClick={() => handleEditCMS(pagina)}
                      className="text-green-600 hover:text-green-800 px-3 py-1 border border-green-600 rounded"
                    >
                      ✏️ Editar
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </CollapsibleSection>

          {/* Modal/Formulario para editar CMS */}
          {showCMSForm && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-gray-900">
                    Editar Página: {cmsFormData.titulo}
                  </h2>
                </div>
                
                <form onSubmit={handleSubmitCMS} className="p-6 space-y-6">
                  {/* Título y Descripción */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Título
                      </label>
                      <input
                        type="text"
                        name="titulo"
                        value={cmsFormData.titulo}
                        onChange={handleCMSInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                        required
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Descripción
                      </label>
                      <input
                        type="text"
                        name="descripcion"
                        value={cmsFormData.descripcion}
                        onChange={handleCMSInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                      />
                    </div>
                  </div>

                  {/* Secciones */}
                  <div>
                    <div className="flex justify-between items-center mb-4">
                      <label className="block text-sm font-medium text-gray-700">
                        Secciones de Contenido
                      </label>
                      <button
                        type="button"
                        onClick={agregarSeccion}
                        className="bg-green-600 text-white px-4 py-2 rounded-lg text-sm"
                      >
                        + Agregar Sección
                      </button>
                    </div>
                    
                    <div className="space-y-4">
                      {cmsFormData.secciones.map((seccion, index) => (
                        <div key={index} className="border border-gray-300 rounded-lg p-4 bg-gray-50">
                          <div className="flex justify-between items-start mb-3">
                            <h4 className="font-medium">Sección {index + 1}</h4>
                            <button
                              type="button"
                              onClick={() => eliminarSeccion(index)}
                              className="text-red-600 hover:text-red-800"
                            >
                              🗑️ Eliminar
                            </button>
                          </div>
                          
                          <div className="space-y-3">
                            <div>
                              <label className="block text-xs font-medium text-gray-700 mb-1">
                                Título de Sección
                              </label>
                              <input
                                type="text"
                                value={seccion.titulo}
                                onChange={(e) => handleSeccionChange(index, 'titulo', e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded"
                                required
                              />
                            </div>
                            
                            <div>
                              <label className="block text-xs font-medium text-gray-700 mb-1">
                                Contenido (HTML permitido)
                              </label>
                              <textarea
                                value={seccion.contenido}
                                onChange={(e) => handleSeccionChange(index, 'contenido', e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded"
                                rows={6}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Botones */}
                  <div className="flex justify-end gap-3 pt-6 border-t">
                    <button
                      type="button"
                      onClick={resetCMSForm}
                      className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                    >
                      Guardar Cambios
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Debug Panel */}
          {process.env.NODE_ENV === 'development' && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mt-8">
              <h4 className="text-sm font-medium text-yellow-800 mb-2">Debug Info</h4>
              <div className="text-xs text-yellow-700 space-y-1">
                <p>API URL: {process.env.REACT_APP_API_URL}</p>
                <p>Total paquetes: {paquetes.length}</p>
                <p>Total secciones: {secciones.length}</p>
                <p>Total paquetes externos: {paquetesExternos.length}</p>
                <p>Usuario: {user?.email} ({user?.role})</p>
                <p>Token exists: {!!localStorage.getItem('token')}</p>
              </div>
            </div>
          )}

          {/* Modal Edición Masiva */}
          {showEdicionMasiva && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Edición Masiva ({paquetesSeleccionados.length} paquetes)
                </h2>
                
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Campo a editar
                    </label>
                    <select
                      value={edicionMasivaData.campo}
                      onChange={(e) => setEdicionMasivaData(prev => ({ ...prev, campo: e.target.value }))}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                    >
                      <option value="">Seleccionar campo</option>
                      <option value="descripcion">Descripción</option>
                      <option value="hotel">Hotel</option>
                      <option value="transporte">Transporte</option>
                      <option value="regimen">Régimen</option>
                      <option value="categoria">Categoría</option>
                      <option value="estado">Estado</option>
                      <option value="destacado">Destacado</option>
                      <option value="incluye_coordinador">Incluye Coordinador</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Nuevo valor
                    </label>
                    {edicionMasivaData.campo === 'categoria' ? (
                      <select
                        value={edicionMasivaData.valor}
                        onChange={(e) => setEdicionMasivaData(prev => ({ ...prev, valor: e.target.value }))}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                      >
                        <option value="">Seleccionar categoría</option>
                        <option value="nacional">Nacional</option>
                        <option value="internacional">Internacional</option>
                        <option value="europa">Europa</option>
                        <option value="cruceros">Cruceros</option>
                      </select>
                    ) : edicionMasivaData.campo === 'estado' ? (
                      <select
                        value={edicionMasivaData.valor}
                        onChange={(e) => setEdicionMasivaData(prev => ({ ...prev, valor: e.target.value }))}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                      >
                        <option value="">Seleccionar estado</option>
                        <option value="activo">Activo</option>
                        <option value="inactivo">Inactivo</option>
                        <option value="agotado">Agotado</option>
                      </select>
                    ) : edicionMasivaData.campo === 'destacado' || edicionMasivaData.campo === 'incluye_coordinador' ? (
                      <select
                        value={edicionMasivaData.valor === true ? "true" : (edicionMasivaData.valor === false ? "false" : "")}
                        onChange={(e) => setEdicionMasivaData(prev => ({ 
                          ...prev, 
                          valor: e.target.value === 'true' ? true : (e.target.value === 'false' ? false : e.target.value)
                        }))}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                      >
                        <option value="">Seleccionar</option>
                        <option value="true">Sí</option>
                        <option value="false">No</option>
                      </select>

                    ) : edicionMasivaData.campo === 'descripcion' ? (
                      <textarea
                        value={edicionMasivaData.valor}
                        onChange={(e) => setEdicionMasivaData(prev => ({ ...prev, valor: e.target.value }))}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg resize-y min-h-[120px] max-h-[300px]"
                        placeholder="Ingresa la descripción..."
                        rows={5}
                      />

                    ) : (
                      <input
                        type="text"
                        value={edicionMasivaData.valor}
                        onChange={(e) => setEdicionMasivaData(prev => ({ ...prev, valor: e.target.value }))}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                        placeholder="Ingresa el nuevo valor"
                      />
                    )}
                  </div>
                </div>

                <div className="flex gap-3 mt-6">
                  <button
                    onClick={() => {
                      setShowEdicionMasiva(false);
                      setEdicionMasivaData({ campo: '', valor: '' });
                    }}
                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleEdicionMasiva}
                    className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                  >
                    Aplicar Cambios
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Modal Gestionar Destaques */}
          {showDestaquesModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-6 border-b border-gray-200 flex justify-between items-center">
                  <h2 className="text-2xl font-bold text-gray-900">
                    🏷️ Gestionar Destaques
                  </h2>
                  <button
                    onClick={() => {
                      setShowDestaquesModal(false);
                      setEditingDestaque(null);
                      setDestaqueForm({ nombre: '', descripcion: '', color: '#FF6B6B', icono: '🎉' });
                    }}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <X size={24} />
                  </button>
                </div>
                
                <div className="p-6">
                  {/* Formulario para crear/editar destaque */}
                  <form onSubmit={editingDestaque ? handleActualizarDestaque : handleCrearDestaque} className="mb-6 p-4 bg-gray-50 rounded-lg">
                    <h3 className="font-semibold mb-4">
                      {editingDestaque ? 'Editar Destaque' : 'Crear Nuevo Destaque'}
                    </h3>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Nombre *
                        </label>
                        <input
                          type="text"
                          value={destaqueForm.nombre}
                          onChange={(e) => setDestaqueForm(prev => ({ ...prev, nombre: e.target.value }))}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                          placeholder="Ej: Navidad"
                          required
                        />
                      </div>
                      
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Icono
                        </label>
                        <input
                          type="text"
                          value={destaqueForm.icono}
                          onChange={(e) => setDestaqueForm(prev => ({ ...prev, icono: e.target.value }))}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                          placeholder="🎄"
                        />
                      </div>
                      
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Color
                        </label>
                        <div className="flex gap-2">
                          <input
                            type="color"
                            value={destaqueForm.color}
                            onChange={(e) => setDestaqueForm(prev => ({ ...prev, color: e.target.value }))}
                            className="w-16 h-12 border border-gray-300 rounded cursor-pointer"
                          />
                          <input
                            type="text"
                            value={destaqueForm.color}
                            onChange={(e) => setDestaqueForm(prev => ({ ...prev, color: e.target.value }))}
                            className="flex-1 px-4 py-3 border border-gray-300 rounded-lg"
                            placeholder="#FF6B6B"
                          />
                        </div>
                      </div>
                      
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Descripción
                        </label>
                        <input
                          type="text"
                          value={destaqueForm.descripcion}
                          onChange={(e) => setDestaqueForm(prev => ({ ...prev, descripcion: e.target.value }))}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                          placeholder="Descripción breve"
                        />
                      </div>
                    </div>
                    
                    <div className="flex gap-3 mt-4">
                      {editingDestaque && (
                        <button
                          type="button"
                          onClick={() => {
                            setEditingDestaque(null);
                            setDestaqueForm({ nombre: '', descripcion: '', color: '#FF6B6B', icono: '🎉' });
                          }}
                          className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
                        >
                          Cancelar
                        </button>
                      )}
                      <button
                        type="submit"
                        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                      >
                        {editingDestaque ? 'Actualizar' : 'Crear Destaque'}
                      </button>
                    </div>
                  </form>
                  
                  {/* Lista de destaques */}
                  <div className="space-y-3">
                    <h3 className="font-semibold mb-4">Destaques Existentes</h3>
                    {destaques.map(destaque => (
                      <div key={destaque.id} className="flex items-center justify-between p-4 bg-white border border-gray-200 rounded-lg">
                        <div className="flex items-center gap-3">
                          <span style={{ backgroundColor: destaque.color }} className="w-12 h-12 rounded-full flex items-center justify-center text-2xl">
                            {destaque.icono}
                          </span>
                          <div>
                            <h4 className="font-semibold">{destaque.nombre}</h4>
                            <p className="text-sm text-gray-600">{destaque.descripcion}</p>
                          </div>
                        </div>
                        <div className="flex gap-2">
                          <button
                            onClick={() => {
                              setEditingDestaque(destaque);
                              setDestaqueForm({
                                nombre: destaque.nombre,
                                descripcion: destaque.descripcion || '',
                                color: destaque.color,
                                icono: destaque.icono
                              });
                            }}
                            className="text-blue-600 hover:text-blue-800 px-3 py-1 border border-blue-600 rounded"
                          >
                            ✏️ Editar
                          </button>
                          <button
                            onClick={() => handleEliminarDestaque(destaque.id)}
                            className="text-red-600 hover:text-red-800 px-3 py-1 border border-red-600 rounded"
                          >
                            🗑️ Eliminar
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal Asignar Destaques */}
          {showAsignarDestaquesModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Asignar Destaques ({paquetesSeleccionados.length} paquetes)
                </h2>
                
                <div className="space-y-3 mb-6">
                  {destaques.map(destaque => (
                    <label key={destaque.id} className="flex items-center gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={destaquesSeleccionados.includes(destaque.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setDestaquesSeleccionados(prev => [...prev, destaque.id]);
                          } else {
                            setDestaquesSeleccionados(prev => prev.filter(id => id !== destaque.id));
                          }
                        }}
                        className="w-5 h-5 rounded border-gray-300"
                      />
                      <span style={{ backgroundColor: destaque.color }} className="w-10 h-10 rounded-full flex items-center justify-center text-xl flex-shrink-0">
                        {destaque.icono}
                      </span>
                      <div className="flex-1">
                        <div className="font-semibold">{destaque.nombre}</div>
                        <div className="text-xs text-gray-500">{destaque.descripcion}</div>
                      </div>
                    </label>
                  ))}
                </div>
                
                <div className="flex gap-3">
                  <button
                    onClick={() => {
                      setShowAsignarDestaquesModal(false);
                      setDestaquesSeleccionados([]);
                    }}
                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleAsignarDestaques}
                    className="flex-1 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
                  >
                    Asignar Destaques
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Modal FAQ Paquetes */}
          {showFAQModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full p-6">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-2xl font-bold text-gray-900">
                    {editingFAQ ? 'Editar Pregunta' : 'Nueva Pregunta Frecuente'}
                  </h2>
                  <button
                    onClick={() => {
                      setShowFAQModal(false);
                      setEditingFAQ(null);
                      setFaqForm({ pregunta: '', respuesta: '', orden: 0 });
                    }}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <X size={24} />
                  </button>
                </div>
                
                <form onSubmit={handleSubmitFAQ} className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Pregunta *
                    </label>
                    <input
                      type="text"
                      value={faqForm.pregunta}
                      onChange={(e) => setFaqForm(prev => ({ ...prev, pregunta: e.target.value }))}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                      placeholder="¿Puedo cancelar mi reserva?"
                      required
                      maxLength={500}
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Respuesta *
                    </label>
                    <textarea
                      value={faqForm.respuesta}
                      onChange={(e) => setFaqForm(prev => ({ ...prev, respuesta: e.target.value }))}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                      rows={4}
                      placeholder="Sí, puedes cancelar tu reserva según nuestras políticas..."
                      required
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Orden (para ordenar las preguntas)
                    </label>
                    <input
                      type="number"
                      value={faqForm.orden}
                      onChange={(e) => setFaqForm(prev => ({ ...prev, orden: parseInt(e.target.value) || 0 }))}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                      min="0"
                    />
                  </div>
                  
                  <div className="flex gap-3 pt-4">
                    <button
                      type="button"
                      onClick={() => {
                        setShowFAQModal(false);
                        setEditingFAQ(null);
                        setFaqForm({ pregunta: '', respuesta: '', orden: 0 });
                      }}
                      className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                    >
                      {editingFAQ ? 'Actualizar' : 'Crear'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

        </div>
      </div>

      <Footer />
    </>
  );
}

export default Admin;